import { ESupportedLocales } from 'store/localization/localization.enums';

export const vocabularyEndPoints = {
  getList: (locale: ESupportedLocales) => `/vocabulary/list/${locale}`,
};
